import { bannerSlider } from './banner/slider';
import { initSliders } from './slider/_main';
import { videoCastPodcast } from './videocastPodcast';
import { cardFloat } from './card-float';
import { servicesSlider } from './slider/services';

export const initWidgets = () => {
    bannerSlider.init();
    videoCastPodcast.init();
    cardFloat.init();
    servicesSlider.init();
    initSliders();
}